import { makeAutoObservable } from 'mobx';
import {successAlert} from 'shared/tools';
import {t} from 'shared/core';

class EmailTemplateEditState {
  store;
  history;
  match;

  emailTemplate;
  errors = {};

  constructor(store, history, match) {
    makeAutoObservable(this, {
      store: false,
      history: false
    });

    this.store = store;
    this.history = history;
    this.match = match;
  }

  async load() {
    this.emailTemplate = await this.store.loadEmailTemplate(this.match.params.id);
  }

  async updateEmailTemplate() {
    const {model, errors} = await this.store.patch(this.emailTemplate);
    this.errors = errors;

    if (model) {
      successAlert(t('company_settings.documents.alerts.Company document saved.'));
      this.goBack();
    }
  }

  goBack() {
    this.history.push('/email-templates');
  }
}

export default EmailTemplateEditState;
